package com.artvending.warden

data class Point(val x: Double, val y: Double)

object GeolocationCalculator {
	fun isInside(rect: List<Point>, point: Point? = null): Boolean {
		if (point == null) return false
		
		//fun aaa(rect: List<Point>, index: Int) = P((commonSettings.geolocationPoints[index].x * 1000000).toInt(), (commonSettings.geolocationPoints[index].y * 1000000).toInt())
		
		fun aaa(index: Int) = P((rect[index].x * 1000000).toInt(), (rect[index].y * 1000000).toInt())
		
		val points = mutableListOf(aaa(0), aaa(1), aaa(2), aaa(3))
		
		var zeroId = 0
		for (i in points.indices) {
			if (points[i].x < points[zeroId].x || (points[i].x == points[zeroId].x && points[i].y < points[zeroId].y)) {
				zeroId = i
			}
		}
		
		val zero = points[zeroId]
		points.removeAt(zeroId)  // Удаляем нулевую точку из списка
		
		// Рассчитываем углы
		val angles = points.map { point ->
			Angle(point.y - zero.y, point.x - zero.x).apply {
				if (a == 0) {
					b = if (b < 0) -1 else 1
				}
			}
		}.sorted()
		
		val query = P((point.x * 1000000).toInt(), (point.y * 1000000).toInt())
		
		var isInside = false
		if (query.x >= zero.x) {
			if (query.x == zero.x && query.y == zero.y) {
				isInside = true
			}
			else {
				val myAngle = Angle(query.y - zero.y, query.x - zero.x).apply {
					if (a == 0) {
						b = if (b < 0) -1 else 1
					}
				}
				
				val it = angles.binarySearch(myAngle)
				val idx = if (it >= 0) it else -(it + 1)
				
				if (idx != angles.size && idx != 0) {
					val p1 = points[idx]
					val p0 = points[idx - 1]
					if (square(p1, p0, query) <= 0) {
						isInside = true
					}
				}
			}
		}
		return isInside
	}
	
	
	fun isInside(point: Point? = null): Boolean {
		for (rect in commonSettings.geolocationPoints)
			if (isInside(rect, point))
				return true
		
		return false
	}
	
	
	data class P(val x: Int, val y: Int)
	
	
	data class Angle(val a: Int, var b: Int) : Comparable<Angle> {
		override fun compareTo(other: Angle): Int {
			return if (b == 0 && other.b == 0) {
				a.compareTo(other.a)
			}
			else {
				val crossProduct = a.toLong() * other.b - b.toLong() * other.a
				when {
					crossProduct < 0 -> -1
					crossProduct > 0 -> 1
					else -> 0
				}
			}
		}
	}
	
	
	// Вычисление площади треугольника
	fun square(a: P, b: P, c: P): Long {
		return a.x.toLong() * (b.y - c.y) +
				b.x.toLong() * (c.y - a.y) +
				c.x.toLong() * (a.y - b.y)
	}
}